import { useFirebaseData } from "../../@shared/hooks/useFirebaseData";
import { Collections } from "../../@core/constants/FirebasePaths";
import { IFAQ } from "../../@core/interfaces/IFAQ";
import { Queries } from "../../@core/constants/Queries";

export const useFAQ = ({ loadData = false }) => {
  const db = useFirebaseData<IFAQ>({
    collectionPath: Collections.faqs._path,
    loadData,
    queries: Queries.trash
  });

  const createFAQ = async (data: IFAQ) => {
    return await db.add(data);
  };

  const updateFAQ = async (id: string, data: Partial<IFAQ>) => {
    await db.update(id, data);
  };

  const deleteFAQ = async (id: string) => {
    await db.trash(id);
  };

  return {
    faqs: db.data,
    createFAQ,
    updateFAQ,
    deleteFAQ,
    fetched: db.fetched
  };
};
